import { connect } from "react-redux";
import moment from "moment";
import classnames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCopy, faTimes, faInfoSquare } from "@fortawesome/pro-light-svg-icons";

import { toast } from "extensions/toast";

import { copyToClipboard } from "common/utils";
import { Tooltip } from "common/components/tooltip";
import { fetchEmailDetails, EMAILS_ADD_FILTER } from "common/actions/email";

import { DetailsTable } from "../common/detailsTable";

const mapStateToProps = (state) => ({
    // Which pieces of state should this component depend on? (cause a retrigger).
    queryDeps: {
        date_range: state.common.date_range,
        qualifiers: state.emails.qualifiers
    }
});

const mapDispatchToProps = {
    addFilter: EMAILS_ADD_FILTER
};

const ui = {
    columns: [
        {
            id: "_id",
            header: "",
            width: 38,
            css: "details-link",
            template: (item) => <span className="tooltipped tooltipped-ne" aria-label="Open email event details"><FontAwesomeIcon icon={faInfoSquare} size="lg" className="open-details"/></span>
        },
        {
            id: "user_email",
            header: "User email",
            adjust: true,
            css: "filter-enable"
        },
        {
            id: "merchant",
            filter: "merchant_ref",
            header: "Merchant",
            adjust: true,
            css: "filter-enable"
        },
        {
            id: "template_type",
            filter: "template_ref",
            header: "Email type",
            adjust: true,
            css: "filter-enable"
        },
        {
            id: "created",
            header: "Created",
            adjust: true,
            css: "filter-enable",
            format: (value) => moment.utc(value).local().format("MM-DD-YYYY h:mm:ss a")
        },
        {
            id: "modified",
            header: "Modified",
            adjust: true,
            css: "filter-enable",
            format: (value) => moment.utc(value).local().format("MM-DD-YYYY h:mm:ss a")
        },
        {
            id: "complaint",
            header: "Complaint",
            adjust: true,
            css: "filter-enable",
            format: (value) => value || "-"
        },
        // { // TODO add package to API (required)
        //     id: "package",
        //     header: "Package",
        //     css: "filter-enable"
        // },
        {
            id: "bounce_reason",
            header: "Bounce reason",
            adjust: true,
            css: "filter-enable",
            format: (value) => value || "-"
        },
        {
            id: "rejected",
            header: "Rejected",
            adjust: true,
            css: "filter-enable",
            format: (value) => (value ? moment.utc(value).local().format("MM-DD-YYYY h:mm:ss a") : "-")
        },
        {
            id: "opened",
            header: "Opened",
            adjust: true,
            css: "filter-enable"
        },
        {
            id: "clicked_link",
            header: "Clicked link",
            adjust: true,
            css: "filter-enable"
        },
        {
            id: "traceback",
            header: "Traceback",
            adjust: true,
            css: "filter-enable",
            format: (value) => (value ? "Internal error" : "-")
        },
        {
            id: "user_ref",
            header: "User ref",
            adjust: true,
            css: "filter-enable"
        },
        {
            id: "aws_id",
            header: "AWS ID",
            adjust: true
        }
    ]
};

const Connected = connect(
    mapStateToProps,
    mapDispatchToProps
)(DetailsTable);

const copyTextToClipboard = (value) => (e) => {
    e.preventDefault();
    copyToClipboard(value);
    toast.success("Copied to clipboard");
};

function Details({ closeDetails, details }) {
    return (
        <div className="details-box">
            <header>
                <div className="title">Email event details
                    <Tooltip title="Copy to clipboard">
                        <span onClick={copyTextToClipboard(JSON.stringify(details, null, 4))}><FontAwesomeIcon className="copy-icon" icon={faCopy} /></span>
                    </Tooltip>
                </div>
                <div className="bar">
                    <Tooltip title="Close details">
                        <span onClick={closeDetails}><FontAwesomeIcon className="close-trans" icon={faTimes} /></span>
                    </Tooltip>
                </div>
            </header>
        
            <div className="txn-wrapper">
                {Object.entries(details).map(([key, value]) => (
                    <div className="pair" key={key}>
                        <div className="key">{key}</div>
                        <div
                            className={classnames("value", { na: value === null })}
                        >{JSON.stringify(value)}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export function EmailDetailsRedux(props) {
    return (
        <Connected
            ui={ui}
            liveUpdates={false}
            queryKey="emails"
            queryFn={fetchEmailDetails}
            renderDetails={(renderProps) => <Details {...renderProps} />}
            {...props}
        />
    );
}
